import * as React from 'react';
import {stylesheet} from 'typestyle';
import {Channel} from '../../../types/Channel';
import {DiagramBuildingBlock, MergedBuildingBlockInstructions, NamedDateRangeWithPreviewDateRange, ReportBuildingBlock} from '../../types/Report';
import LineChartPreview from '../PaperSheetBlocks/LineChartPreview';

interface PreviewDiagramBlockProps {
    targetCurrency?: string;
    buildingBlock: DiagramBuildingBlock;
    selectedNamedDateRange?: NamedDateRangeWithPreviewDateRange;
    selectedNamedCompareDateRange?: NamedDateRangeWithPreviewDateRange;
    getFullChannelForChannelName: (channelName: string) => Channel;
    getMergedBuildingBlockInstructions: (buildingBlock: ReportBuildingBlock) => MergedBuildingBlockInstructions;
}

export default function PreviewDiagramBlock({
    targetCurrency,
    buildingBlock,
    selectedNamedDateRange,
    selectedNamedCompareDateRange,
    getFullChannelForChannelName,
    getMergedBuildingBlockInstructions,
}: PreviewDiagramBlockProps) {
    const mergedBuildingBlockInstructions = getMergedBuildingBlockInstructions(buildingBlock);
    const {searchDiagrams, productDiagrams} = mergedBuildingBlockInstructions.diagramInstruction
        ? mergedBuildingBlockInstructions.diagramInstruction
        : {searchDiagrams: [], productDiagrams: []};
    if (
        mergedBuildingBlockInstructions.diagramInstruction &&
        selectedNamedDateRange &&
        (searchDiagrams.length > 0 || productDiagrams.length > 0) &&
        (productDiagrams.length === 0 || searchDiagrams.length === 0)
    ) {
        return (
            <div className={diagramBlockCss.diagramPreviewContainer}>
                <LineChartPreview
                    targetCurrency={targetCurrency}
                    dateRange={selectedNamedDateRange.previewDateRange}
                    compareDateRange={selectedNamedCompareDateRange ? selectedNamedCompareDateRange.previewDateRange : undefined}
                    mergedBuildingBlockInstructions={mergedBuildingBlockInstructions}
                    getFullChannelForChannelName={getFullChannelForChannelName}
                />
            </div>
        );
    }
    return null;
}

const diagramBlockCss = stylesheet({
    diagramPreviewContainer: {
        position: 'relative',
        height: 300,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PreviewPaperSheetBlocks/PreviewDiagramBlock.tsx